import { Actions, ofActionSuccessful } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { CustomAttribute, NewRelicService } from './newrelic-analytics.service';
import { NewRelicAnalytics } from './newrelic.action';

@Injectable({
  providedIn: 'root',
})
export class NewrelicActionhandler {
  constructor(private actions$: Actions, private _newrelic: NewRelicService) {}

  initNewRelic$ = this.actions$
    .pipe(
      ofActionSuccessful(NewRelicAnalytics.InitNewRelicAction),
      tap(() => {
        this._newrelic.init();
      })
    )
    .subscribe(() => {
      //console.log(`NewRelic is called`);
    });

  setAttributes$ = this.actions$
    .pipe(
      ofActionSuccessful(NewRelicAnalytics.SetNewRelicActionAttributes),
      tap((action: { data: CustomAttribute | CustomAttribute[] }) => {
        const data = action.data;
        this._newrelic.setCustomAttribute(data);
      })
    )
    .subscribe(() => {
      // console.log(`${NewRelic.setAttributes} is called`);
    });
}
